import L from '../leaflet-plugins-loader';
import { LeafletService } from '../leaflet.service'
import { TranslateService } from '@ngx-translate/core'
import { WidgetSettingsObserveService } from '../../../../shared/services/helpers/widget-settings-observe.service'
import { ILeafletInstance } from '../leaflet.interface'

const OpenStreetMap_DE = L.tileLayer('https://tile.openstreetmap.de/{z}/{x}/{y}.png', {
  maxZoom: 18,
  attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
})

const OpenStreetMap_Mapnik = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
  maxZoom: 19,
  attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
});

const Esri_WorldTopoMap = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}', {
  attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community'
});

export class OpenStreetMap extends LeafletService {
  private static readonly ressourceUrl: string = 'https://tile.openstreetmap.de/{z}/{x}/{y}.png'
  private static readonly options = {
    maxZoom: 20,
    minZoom: 3,
    maxNativeZoom: 19,
    detectRetina: false,
    updateWhenIdle: true,     // load tiles when user stops moving map (better performance)
    updateWhenZooming: false,
    attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
  }

  constructor(translate: TranslateService, widgetSettingObserve: WidgetSettingsObserveService) {
    super(translate, widgetSettingObserve)
  }

  static addOSMBaseLayer(id: number | string, instance?: ILeafletInstance): void {
    const osmLayer = L.tileLayer(OpenStreetMap.ressourceUrl,OpenStreetMap.options)

    if (instance) {
      Object.assign(instance.tileLayers, {
        'OSM': {
          url: OpenStreetMap.ressourceUrl,
          layer: osmLayer,
          zoom: 10,
          id: `map_${id}`
        }
      })
    }

  }

  static addMiniMapLayerToInstance(id: number | string, instance?: ILeafletInstance) {
    if (instance?.layerControls.has(`minimap_${id}`)) {
      const miniMapControl = instance?.layerControls.get(`minimap_${id}`)
      if (miniMapControl) {
        instance.map.removeControl(miniMapControl)
      }
      instance.layerControls.delete(`minimap_${id}`)
    }

    if (instance) {
      // L.Control cannot reuse the same tileLayer
      const minimMapTileLayer = L.tileLayer(OpenStreetMap.ressourceUrl,OpenStreetMap.options)

      const miniMap = new L.Control.MiniMap(minimMapTileLayer, {
        width: 215,
        height: 215,
        position: 'topright',
        toggleDisplay: true,
        minimized: true,
        zoomLevelOffset: -5
      }) as any

      miniMap.on('restore', () => {
        miniMap._miniMap.invalidateSize();
      });

      instance.layerControls.set(`minimap_${id}`, miniMap);
      miniMap.addTo(instance?.map)
    }
  }
}
